import { useEffect, useState } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";

export interface WorkItemDropdownValues {
    contentTypes: WorkItemLOV[],
    responsibilities: WorkItemLOV[],
    workSpaces: WorkItemLOV[]
}

export interface WorkItemLOV {
    id: string,
    name: string,
}

type WorkItemLOVResult = [
    WorkItemDropdownValues | null,
    boolean,
    string | null
];


const useWorkItemListOfValues: () => WorkItemLOVResult = () => {
    const [ result, setResult ] = useState<WorkItemDropdownValues | null>(null);
    const [ error, setError ] = useState<string | null>(null);
    const [ loading, setLoading ] = useState<boolean>(true);    
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {        
        const controller = new AbortController();
        const fetchTasks = async () => {            
            if (user && user.id_token) {
                setLoading(true);
                try {

                    const resp = await fetcher(`/api/v3/bulkupdate/workitem/ListOfValues`, {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // RESPOND TO ERRORS
                    }

                    const data = await resp.json();
                    setResult(data);
                } catch (err) {
                    // TODO: 
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(true);
                setResult(null);
                setLoading(false);
            }
        };
        fetchTasks()
        .catch((err) => {});

        return () => {
            controller.abort();
            setLoading(false);
        };
    }, [ user ]);

    return [
        result,
        loading,
        error
    ];
};

export default useWorkItemListOfValues;